/* =============================================================
   JMM Contact — cartes de service : sans présélection, le
   formulaire reste verrouillé (grisé) jusqu'au choix, puis
   s'éveille et se configure (exemple, bouton, astuce, bandeau
   café, champ caché Service). Présélection par URL
   (?service=handle) = déverrouillage direct. Pré-remplissage
   ?msg=… . Sans JS : formulaire actif normalement.
   ============================================================= */
(function () {
  'use strict';

  function initJmt(root) {
    if (root.getAttribute('data-jmt-init') === '1') return;
    root.setAttribute('data-jmt-init', '1');

    var pills = [].slice.call(root.querySelectorAll('[data-jmt-pill]'));
    if (!pills.length) return;
    var msg = root.querySelector('[data-jmt-msg]');
    var cta = root.querySelector('[data-jmt-cta]');
    var hint = root.querySelector('[data-jmt-hint]');
    var hidden = root.querySelector('[data-jmt-service]');
    var notes = [].slice.call(root.querySelectorAll('[data-jmt-note]'));
    var card = root.querySelector('.jmt__card');

    function sel(handle) {
      var pill = root.querySelector('[data-jmt-pill="' + handle + '"]') || pills[0];
      handle = pill.getAttribute('data-jmt-pill');
      if (root.classList.contains('is-locked')) {
        root.classList.remove('is-locked');
        if (card) {
          card.classList.add('is-wake');
          window.setTimeout(function () { card.classList.remove('is-wake'); }, 500);
        }
      }
      pills.forEach(function (p) { p.classList.toggle('is-on', p === pill); });
      if (msg) msg.placeholder = pill.getAttribute('data-ph') || '';
      if (cta) cta.textContent = pill.getAttribute('data-cta') || cta.textContent;
      if (hint) {
        var h = pill.getAttribute('data-hint') || '';
        hint.textContent = h;
        hint.style.display = h ? '' : 'none';
      }
      if (hidden) hidden.value = pill.getAttribute('data-name') || handle;
      notes.forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-jmt-note') === handle); });
    }

    function lock() {
      root.classList.add('is-locked');
      pills.forEach(function (p) { p.classList.remove('is-on'); });
      notes.forEach(function (n) { n.classList.remove('is-on'); });
      var lp = root.getAttribute('data-jmt-lockedph');
      if (msg && lp) msg.placeholder = lp;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () { sel(p.getAttribute('data-jmt-pill')); });
    });

    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('service');
    if (wanted) {
      sel(wanted);
    } else if (root.getAttribute('data-jmt-require') === 'true') {
      lock();
    } else {
      sel(pills[0].getAttribute('data-jmt-pill'));
    }
    if (params.get('msg') && msg && !msg.value) msg.value = params.get('msg');
  }

  function initAll() { document.querySelectorAll('[data-jmt]').forEach(initJmt); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
